export function Intro() {
    return (
        <p className="text-sm text-gray-500">These promotions are shown within the user's mobile app and can be time-based by setting a start and end date.</p>
    );
}

export default Intro;